import React from 'react';
import type { IconProps } from '../types';

/** Sparkles / "AI" icon (Gemini-style 4-point stars). Uses currentColor so it
 *  follows the tab's active/inactive color. */
export const TabAI = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3.2l1.9 5.0 5.0 1.9-5.0 1.9-1.9 5.0-1.9-5.0-5.0-1.9 5.0-1.9z"
      fill="currentColor"
    />
    <path
      d="M18.5 14.2l.85 2.25 2.25.85-2.25.85-.85 2.25-.85-2.25-2.25-.85 2.25-.85z"
      fill="currentColor"
    />
  </svg>
);

export default TabAI;
